"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriveSettingsFactory = void 0;
var MB4 = 4 * 1024 * 1024;
var KB100 = 100 * 1024;
var DriveSettingsFactory = /** @class */ (function () {
    function DriveSettingsFactory() {
    }
    DriveSettingsFactory.getForDrive1Test = function () {
        return {
            apiUrl: "https://api.testkontur.ru/drive/v1/",
            chunkSizeBytes: MB4,
            partialUploadSizeThresholdBytes: KB100,
            requestsMaxAttempts: 3,
        };
    };
    DriveSettingsFactory.getForDrive2Test = function () {
        return {
            apiUrl: "https://api.testkontur.ru/drive/v2/",
            chunkSizeBytes: MB4,
            partialUploadSizeThresholdBytes: KB100,
            requestsMaxAttempts: 3,
        };
    };
    DriveSettingsFactory.getForDrive2 = function (apiUrl) {
        if (apiUrl === void 0) { apiUrl = "https://api.kontur.ru/drive/v2/"; }
        return {
            apiUrl: apiUrl,
            chunkSizeBytes: MB4,
            partialUploadSizeThresholdBytes: KB100,
            requestsMaxAttempts: 3,
        };
    };
    DriveSettingsFactory.getForDrive1 = function (apiUrl) {
        if (apiUrl === void 0) { apiUrl = "https://api.kontur.ru/drive/v1/"; }
        return {
            apiUrl: apiUrl,
            chunkSizeBytes: MB4,
            partialUploadSizeThresholdBytes: KB100,
            requestsMaxAttempts: 3,
        };
    };
    return DriveSettingsFactory;
}());
exports.DriveSettingsFactory = DriveSettingsFactory;
